export default "__VITE_ASSET__088278cf__"